import { render, staticRenderFns } from "./PnlVencimentosServicos.vue?vue&type=template&id=0ee91e3f"
import script from "./PnlVencimentosServicos.vue?vue&type=script&lang=js"
export * from "./PnlVencimentosServicos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports